import {Component, OnInit, Input} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {DataHandlerService} from '../../../services/data-handler.service';

/**
 * The base component for all widget panels
 */
@Component({
    selector: 'app-wizard-widget',
    templateUrl: './wizard-widget.component.html',
    standalone: true
})
export class WizardWidgetComponent implements OnInit {
  @Input() public formGroup: UntypedFormGroup;
  @Input() public opts: any = {};
  @Input() public navigator: BehaviorSubject<String>;

  constructor(public dataHandlerService: DataHandlerService) {
  }

  ngOnInit() {
    this.opts = this.opts || {};
  }

  getIncomeLabel(income, frequencyTypes, incomeTypes) {
    const frequencyResult = frequencyTypes.find(x => x.id === income.value.frequency);
    const incomeResult = incomeTypes.find(x => x.id === income.value.type);

    if (frequencyResult && incomeResult) {
      const frequencyTextLabel = (frequencyResult.text === 'Annually') ? 'Annual' : frequencyResult.text;
      const incomeTextLabel: string = (incomeResult.ext.label) ? incomeResult.ext.label : incomeResult.text;

      /** Special terms */
      const terms = ["net", "gross"];

      const lowerIncomeTextLabel = incomeTextLabel?.toLowerCase();
      if (!terms.some((word: string) => lowerIncomeTextLabel?.includes(word))) {
        /** Add 'Gross' if the income text label doesn't contain any 'net' or 'gross' word */
        return `${frequencyTextLabel} Gross ${incomeTextLabel} amount`;
      }

      /** If incomeTextLabel has 'net', or 'gross', return original format */
      return `${frequencyTextLabel} ${incomeTextLabel} amount`;
    } else {
      return 'Amount';
    }
  }
}
